/**
 * Top.Mail.Ru counter (VK Ads pixel). Loaded only on public marketing pages.
 * Set VITE_MAILRU_COUNTER_ID at build time (see frontend/.env.example).
 */

const SCRIPT_ID = 'tmr-code'
const NOSCRIPT_ID = 'tmr-noscript-pixel'

declare global {
  interface Window {
    _tmr?: Record<string, unknown>[]
    opera?: string
  }
}

export function getMailRuCounterId(): string | null {
  const id = import.meta.env.VITE_MAILRU_COUNTER_ID?.trim()
  return id || null
}

function injectLoaderScript(): void {
  if (document.getElementById(SCRIPT_ID)) return

  const ts = document.createElement('script')
  ts.type = 'text/javascript'
  ts.async = true
  ts.id = SCRIPT_ID
  ts.src = 'https://top-fwz1.mail.ru/js/code.js'

  const insert = () => {
    const first = document.getElementsByTagName('script')[0]
    if (first?.parentNode) {
      first.parentNode.insertBefore(ts, first)
    } else {
      document.head.appendChild(ts)
    }
  }

  if (window.opera === '[object Opera]') {
    document.addEventListener('DOMContentLoaded', insert, false)
  } else {
    insert()
  }
}

function injectNoScriptPixel(counterId: string): void {
  if (document.getElementById(NOSCRIPT_ID)) return

  const wrap = document.createElement('div')
  wrap.id = NOSCRIPT_ID
  wrap.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;'

  const img = document.createElement('img')
  img.src = `https://top-fwz1.mail.ru/counter?id=${counterId};js=na`
  img.alt = 'Top.Mail.Ru'
  img.style.cssText = 'position:absolute;left:-9999px;'

  wrap.appendChild(img)
  document.body.appendChild(wrap)
}

/** Load counter script and send pageView (safe to call on each public page mount). */
export function initMailRuCounter(): void {
  const counterId = getMailRuCounterId()
  if (!counterId || typeof document === 'undefined') return

  window._tmr = window._tmr || []
  window._tmr.push({
    id: counterId,
    type: 'pageView',
    start: new Date().getTime(),
  })

  injectLoaderScript()
  injectNoScriptPixel(counterId)
}

/** Custom conversion goal in VK / Top.Mail.Ru cabinet. */
export function trackMailRuReachGoal(goal: string): void {
  const counterId = getMailRuCounterId()
  if (!counterId || !goal.trim()) return

  window._tmr = window._tmr || []
  window._tmr.push({
    id: counterId,
    type: 'reachGoal',
    goal: goal.trim(),
  })
}
